import {cn} from 'platform/shared-tw';

import {useId} from 'react';

import {
  createKeyDownHandler,
  partFill,
  partStroke,
  type DiagramVariant,
} from '../shared/partVariants';

const WINDSCREEN_WASH_FLUID_TITLE_ID = 'windscreen-wash-fluid-title';

interface WindscreenWashFluidProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function WindscreenWashFluid(props: WindscreenWashFluidProps) {
  const uid = useId();
  const titleId = `${WINDSCREEN_WASH_FLUID_TITLE_ID}-${uid}`;

  return (
    <svg
      width="63"
      height="46"
      viewBox="0 0 63 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`absolute focus:outline-none focus-visible:outline-none ${props.onClick ? 'cursor-pointer group' : ''}`}
      style={{top: 46, left: 94}}
      onClick={props.onClick}
      onKeyDown={createKeyDownHandler(props.onClick)}
      role={props.onClick ? 'button' : undefined}
      tabIndex={props.onClick ? 0 : undefined}
      aria-labelledby={titleId}
    >
      <title id={titleId}>Windscreen Wash Fluid</title>
      <path
        d="M53.5 45H9C1 45 1 37 1 37V27C1 20 7 16.5 7 16.5C12 13 33 1 46 1H53.5C53.5 1 62 1 62 9.5V36.5C62 36.5 62 45 53.5 45Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}), props.onClick ? 'cursor-pointer' : '')}
      />
      <path
        d="M53.5 45H9C1 45 1 37 1 37V27C1 20 7 16.5 7 16.5C12 13 33 1 46 1H53.5C53.5 1 62 1 62 9.5V36.5C62 36.5 62 45 53.5 45Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <circle
        cx="17"
        cy="29"
        r="8"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        x="8.99997"
        y="27"
        width="10"
        height="4"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
